(() => {
  if (window.LeproProductCardActions) return;

  // Clone the Liquid-rendered component so dynamic cards share markup and translations.
  window.LeproProductCardActions = {
    render({ scope, product, variant, quantity = 1, className = '', checkoutDirect = false }) {
      const template = scope.closest('.shopify-section')?.querySelector('[data-product-card-actions-template]');
      if (!template) throw new Error('Product card actions template missing');
      const wrapper = document.createElement('div');
      wrapper.appendChild(template.content.cloneNode(true));
      const actions = wrapper.querySelector('.collection-product-detail-trigger');
      className.split(/\s+/).filter(Boolean).forEach(name => actions.classList.add(name));
      const buy = actions.querySelector('.collection-product-detail__card-buy');
      const open = actions.querySelector('.collection-product-detail__card-open');
      const soldOut = variant.available === false;
      const url = new URL(product.url || `${window.Shopify?.routes?.root || '/'}products/${product.handle}`, location.origin);
      actions.classList.toggle('is-sold-out', soldOut);
      buy.disabled = open.disabled = soldOut;
      buy.dataset.id = variant.id;
      buy.dataset.quantity = quantity;
      if (checkoutDirect) buy.dataset.checkoutDirect = open.dataset.checkoutDirect = 'true';
      else {
        delete buy.dataset.checkoutDirect;
        delete open.dataset.checkoutDirect;
      }
      buy.dataset.coupon = window.isB2BCustomer ? '' : (variant.metafields?.custom?.variants_discounts_and_marketing?.product_detail_max_discount?.code || '');
      buy.querySelector('.btn-label').textContent = soldOut ? actions.dataset.soldOutLabel : actions.dataset.buyLabel;
      open.dataset.collectionDetailUrl = url.pathname + url.search;
      open.dataset.collectionDetailVariant = variant.id;
      open.dataset.collectionDetailQuantity = quantity;
      open.setAttribute('aria-label', `${open.getAttribute('aria-label').replace(/:\s*$/, '')}: ${product.title}`);
      return wrapper.innerHTML;
    },
  };
})();
